<template>
    <div class="row row-cards row-deck">
        <div class="col-12">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title">Filtres</h3>
                </div>
                <div class="card-body">
                    <form @submit.prevent="search(false)" class="form" id="search" action="/pro/recipes/dashboard">
                        <div class="form-group">
                            <label class="form-label">Rechercher par utilisateur</label>
                            <input v-model="filters.user" name="user" type="text" class="form-control form-control-lg" placeholder="Email, nom/prenom, id.">
                        </div>
                        <div class="form-group" v-if="admin">
                            <label class="form-label">Rôle de l'utilisateur</label>
                            <select v-model="filters.role_id" name="role_id" class="form-control custom-select">
                                <option :value="null">Sélectionner un rôle</option>
                                <option v-for="role in roles" :value="role.id">{{ role.name }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Catégorie</label>
                            <select v-model="filters.category_id" name="category_id" class="form-control custom-select">
                                <option :value="null">Sélectionner une catégorie</option>
                                <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label class="form-label">Recettes</label>
                            <el-select
                                v-model="filters.recipes"
                                multiple
                                filterable
                                remote
                                reserve-keyword
                                placeholder="Entrez un mot-clé"
                                :remote-method="remoteSearchRecipes"
                                :loading="loadingRecipes">
                                <el-option
                                    v-for="item in recipes"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </form>
                </div>
                <div class="card-footer">
                    <button type="submit" form="search" name="search" value="1" class="btn btn-primary">Valider</button>
                    <a v-if="hasFilters" @click.prevent="reset" href="/pro/recipes/dashboard" class="btn btn-danger">Réinitialiser</a>
                    <!--<button type="submit" form="search" name="export-xlsx" value="1" class="btn btn-secondary">Exporter Excel</button>-->
                    <button type="button" @click.prevent="search(true)" form="search" name="refresh" value="1" class="btn btn-secondary">Rafraichir</button>
                </div>
            </div>
        </div>

        <div class="col-12" v-if="loadingTopCreators || loading">
            <div class="alert alert-info" role="alert">
                Nous calculons vos indicateurs, cela peut prendre un peu de temps, merci de votre patience.
            </div>
        </div>

        <template v-if="admin">
            <div class="col-12" v-loading="loadingTopCreators">
                <table class="table table-bordered table-striped">
                    <thead>
                    <tr>
                        <th>Utilisateur</th>
                        <th>Nombre de recettes totales</th>
                        <th>Nombre de recettes catégorisées (entrée, plat, dessert) </th>
                        <th>% Score environnemental A</th>
                        <th>% Score environnemental B</th>
                        <th>Moyenne gCO2e</th>
                        <th>Moyenne gCO2e par plat (*)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(user, key) in topCreators" :key="'top-creator-' + key">
                        <td>
                            <a href="#" @click.prevent="filterByUser(user)">{{ user.user_name }}</a><br>
                            <small>({{ user.user_id }}) {{ user.user_email }}</small>
                        </td>
                        <td>{{ user.recipes_count_total.toLocaleString() }}</td>
                        <td>{{ user.recipes_count.toLocaleString() }}</td>
                        <td>{{ user.percent_ecoscore_a }}%</td>
                        <td>{{ user.percent_ecoscore_b }}%</td>
                        <td>{{ user.moyenne_gco2e.toLocaleString() }}</td>
                        <td>{{ user.moyenne_gco2e_plats.toLocaleString() }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="mb-4">
                <small>*moyenne gCO2e par plat principal (hors entrées et desserts)</small>
            </div>
        </template>

        <div class="col-12" v-loading="loading">
            <div class="row row-cards">
                <div v-for="(chart, key) in charts" :key="'widget-charts-' + key" class="col-6 col-sm-6 col-lg-6">
                    <div class="card">
                        <apexchart type="bar" height="350" @dataPointSelection="handleClickBar" :options="getChartOption(chart.chart.chartOptions)" :series="chart.chart.series"></apexchart>
                    </div>
                </div>
            </div>
        </div>


        <div class="col-12" v-loading="loading">
            <div class="row row-cards">
                <div v-for="(widget, key) in widgets" :key="'widget-' + key" class="col-3 col-sm-3 col-lg-3">
                    <div class="card">
                        <div v-if="widget.format !== 'array'" class="card-body p-3 text-center stat-ctn">
                            <div>
                                <template v-if="typeof widget.value === 'object'">
                                    <div class="h1 m-0">
                                        {{ widget.name }}
                                    </div>
                                    <div class="mt-5">
                                        <div  v-for="(value, index) in widget.value" :key="widget.name+'-'+key+'-'+index">
                                            <i :class="widget.icon"></i><strong>{{ value.title }} :</strong> {{ value.value.toLocaleString() }} {{ widget.unit }}
                                        </div>
                                    </div>

                                </template>
                                <template v-else>
                                    <div class="h1 m-0">
                                        <template v-if="widget.value_letter">
                                            <svg viewBox="0 0 40 44" class="icon icon-letter" :class="colorsLetter[widget.value_letter]" style="width:vpx; height : 36px">
                                                <g v-if="widget.value_letter == 'a'" id="lettre-a" class="icon">
                                                    <path fill="#42B18C" d="M35.933,9.284L22.037,1.18c-1.541-0.843-3.404-0.843-4.946,0L3.195,9.284
			C1.623,10.147,0.652,11.806,0.67,13.6v16.105c-0.018,1.794,0.953,3.452,2.525,4.315l13.896,8c1.542,0.843,3.405,0.843,4.946,0
			l13.896-8c1.571-0.863,2.543-2.521,2.526-4.315V13.6C38.476,11.806,37.504,10.147,35.933,9.284"/>
                                                    <path fill="#FFFFFF" d="M24.881,32.021l-1.475-5.053h-7.684l-1.475,5.053H9.406l7.475-21.157h5.474l7.474,21.157H24.881z
			 M22.354,23.284c-1.368-4.526-2.211-7.054-2.421-7.685s-0.316-1.053-0.421-1.368c-0.316,1.264-1.263,4.316-2.737,9.158h5.579
			V23.284z"/>
                                                </g>
                                                <g v-if="widget.value_letter == 'b'" id="lettre-b" class="icon">
                                                    <path fill="#CDCE2B" d="M36.369,9.684L22.475,1.58c-1.543-0.843-3.406-0.843-4.947,0L3.633,9.684
			C2.061,10.547,1.09,12.206,1.105,14v16.105c-0.016,1.794,0.955,3.452,2.527,4.315l13.895,8c1.541,0.843,3.404,0.843,4.947,0
			l13.895-8c1.572-0.863,2.543-2.521,2.525-4.315V14C38.912,12.206,37.941,10.547,36.369,9.684"/>
                                                    <path fill="#FFFFFF" d="M12.791,11.367h6.523c2.949,0,5.16,0.422,6.527,1.264c1.354,0.861,2.123,2.4,2,4
			c0.041,1.08-0.254,2.146-0.842,3.054c-0.555,0.769-1.383,1.296-2.314,1.474v0.104c1.135,0.154,2.16,0.762,2.842,1.684
			c0.635,0.964,0.932,2.112,0.842,3.263c0.039,1.754-0.738,3.427-2.105,4.526c-1.668,1.142-3.666,1.696-5.684,1.579h-7.895V11.367
			H12.791z M17.211,19.684h2.633c0.906,0.045,1.811-0.136,2.631-0.526c0.584-0.448,0.9-1.161,0.842-1.895
			c0.061-0.676-0.266-1.327-0.842-1.685c-0.893-0.398-1.865-0.578-2.842-0.525h-2.316v4.632L17.211,19.684z M17.211,23.263v5.474
			h2.947c0.971,0.092,1.943-0.17,2.736-0.737c0.648-0.539,0.967-1.377,0.842-2.211c0-1.789-1.262-2.631-3.789-2.631h-2.736V23.263z"
                                                    />
                                                </g>
                                                <g v-if="widget.value_letter == 'c'" id="lettre-c" class="icon">
                                                    <path fill="#FBE818" d="M36.433,10.14L22.537,2.035c-1.541-0.843-3.404-0.843-4.946,0L3.695,10.14
			c-1.572,0.863-2.543,2.521-2.525,4.315v16.105c-0.018,1.794,0.953,3.452,2.525,4.315l13.896,8c1.542,0.843,3.405,0.843,4.946,0
			l13.896-8c1.571-0.863,2.543-2.521,2.526-4.315V14.455C38.976,12.661,38.004,11.003,36.433,10.14"/>
                                                    <rect x="9.906" y="10" fill="none" width="43.344" height="33.508"/>
                                                    <path fill="#FFFFFF" d="M21.698,14.855c-1.709,0-3.032,0.642-3.97,1.926s-1.406,3.074-1.406,5.369
			c0,4.775,1.792,7.163,5.376,7.163c1.504,0,3.325-0.376,5.464-1.128v3.809c-1.758,0.732-3.721,1.099-5.889,1.099
			c-3.115,0-5.498-0.945-7.148-2.834s-2.476-4.602-2.476-8.137c0-2.227,0.405-4.177,1.216-5.852s1.975-2.959,3.494-3.853
			c1.518-0.894,3.298-1.34,5.339-1.34c2.08,0,4.17,0.503,6.27,1.509l-1.465,3.691c-0.801-0.381-1.606-0.713-2.417-0.996
			S22.479,14.855,21.698,14.855z"/>
                                                </g>
                                                <g v-if="widget.value_letter == 'd'" id="lettre-d" class="icon">
                                                    <path fill="#ED8C00" d="M36.433,10.14L22.537,2.035c-1.541-0.843-3.404-0.843-4.946,0L3.695,10.14
			c-1.572,0.863-2.543,2.521-2.525,4.315v16.105c-0.018,1.794,0.953,3.452,2.525,4.315l13.896,8c1.542,0.843,3.405,0.843,4.946,0
			l13.896-8c1.571-0.863,2.543-2.521,2.526-4.315V14.455C38.976,12.661,38.004,11.003,36.433,10.14"/>
                                                    <rect x="9.906" y="10" fill="none" width="43.344" height="33.508"/>
                                                    <path fill="#FFFFFF" d="M30.37,21.887c0,3.525-1.003,6.226-3.011,8.101c-2.006,1.875-4.904,2.812-8.693,2.812h-6.064V11.384h6.724
			c3.496,0,6.211,0.923,8.145,2.769S30.37,18.576,30.37,21.887z M25.653,22.004c0-4.6-2.031-6.899-6.094-6.899h-2.417V29.05h1.948
			C23.466,29.05,25.653,26.701,25.653,22.004z"/>
                                                </g>
                                                <g v-if="widget.value_letter == 'e'" id="lettre-e" class="icon">
                                                    <path fill="#d3676e" d="M36.433,10.14L22.537,2.035c-1.541-0.843-3.404-0.843-4.946,0L3.695,10.14
			c-1.572,0.863-2.543,2.521-2.525,4.315v16.105c-0.018,1.794,0.953,3.452,2.525,4.315l13.896,8c1.542,0.843,3.405,0.843,4.946,0
			l13.896-8c1.571-0.863,2.543-2.521,2.526-4.315V14.455C38.976,12.661,38.004,11.003,36.433,10.14"/>
                                                    <rect x="11.906" y="9.75" fill="#d3676e" width="43.344" height="33.508"/>
                                                    <path fill="#FFFFFF" d="M26.936,32.55H14.602V11.134h12.334v3.721h-7.793v4.702h7.251v3.721h-7.251V28.8h7.793V32.55z"/>
                                                </g>
                                            </svg>
                                        </template>
                                        <i :class="widget.icon"></i>{{ widget.value.toLocaleString() }} {{ widget.unit }}
                                    </div>
                                    <div class="text-muted">{{ widget.name }}</div>

                                </template>

                            </div>
                        </div>
                        <div v-else class="card-body p-1 text-center stat-ctn">
                            <table class="table table-striped table-bordered">
                                <thead>
                                <tr>
                                    <th>{{ widget.name }}</th>
                                    <th>{{ widget.unit }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(value, keyTab) in widget.value" :key="widget.name+'-'+key+'-'+keyTab">
                                    <td>{{ keyTab }}</td>
                                    <td>{{ value.toLocaleString() }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <small v-if="widget.info" class="text-muted">{{ widget.info }}</small>
                </div>
            </div>
        </div>
        <div>
            <small>*Entrée, plat, dessert, hors boissons et préparation</small>
        </div>
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
export default {
    components: {
        apexchart: VueApexCharts,
    },
    name: "DashboardRecipes",
    data() {
        return {
            filters: {
                user: null,
                category_id: null,
                role_id: null,
                recipes: [],
            },
            hasFilters: false,
            loading: false,
            loadingRecipes: false,
            categories: [],
            roles: [],
            widgets: [],
            controller: null,
            controllerRecipe: null,
            recipes: [],
            topCreators: [],
            loadingTopCreators: false,
            colorsLetter: {
                a: 'turquoise',
                b: 'kaki',
                c: 'jaune',
                d: 'orange',
                e: 'rouge',
            },
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'bar',
                },
                colors: ['#009245', '#00d066', '#ffc600', '#ff7600', '#fc0000', '#00b342'],
                plotOptions: {
                    bar: {
                        distributed: true,
                        borderRadius: 10,
                        dataLabels: {
                            position: 'top', // top, center, bottom
                        },
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return val + "%";
                    },
                    offsetY: -25,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                },
                xaxis: {
                    categories: ["A", "B", "C", "D", "E"],
                    position: 'bottom',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: false,
                    }

                },
                legend: {
                    show: false
                },
                title: {
                    text: '',
                    floating: false,
                    align: 'center',
                    style: {
                        color: '#444'
                    }
                }
            },
        }
    },
    props: {
        admin: {
            default: 0
        }
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.hasFilters = Object.values(val).filter((v)=>v).length > 0
            },
            deep: true
        }
    },
    computed: {
        charts() {
            return this.widgets ? Object.values(this.widgets).filter((w)=>w.chart) : [];
        },
    },
    async mounted() {
        this.categories = await axios.get('/pro/recipes/categories').then((r)=>r.data)
        if(this.admin) {
            this.roles = await axios.get('/pro/roles').then((r)=>r.data)
            this.search()
            this.loadingTopCreators = true
            this.topCreators = await axios.get('/pro/recipes/topCreators').then((r)=>r.data.users)
            this.loadingTopCreators = false
        }
    },
    methods: {
        handleClickBar(event, chartContext, config) {
            const { dataPointIndex, seriesIndex } = config;
            console.log(chartContext);
            const selectedLabel = chartContext.opts.xaxis.categories[dataPointIndex];
            const selectedValue = chartContext.opts.series[seriesIndex].data[dataPointIndex];
            const id = chartContext.opts.chart.id;

            const url = `/pro/recipes?${id}=${selectedLabel}`
            window.open(url, '_blank');
        },
        getChartOption(options) {
            return {
                ...this.chartOptions,
                ...options
            }
        },
        async reset() {
            this.filters = {
                user: null,
                category_id: null,
                recipes: [],
            }
            await this.search()
        },
        async search(refresh = false)
        {
            if(this.controller) {
                this.controller.abort();
            }
            this.controller = new AbortController();

            this.loading = true

            if(refresh) {
                refresh = 1
            } else {
                refresh = 0
            }

            try {
                let response = await axios.get('/pro/recipes/dashboard', {
                    params: {...this.filters, refresh },
                    signal: this.controller.signal
                });
                this.widgets = response.data.widgets;
            } catch (e) {
                console.log(e)
            }
            this.loading = false

        },
        async remoteSearchRecipes(query)
        {
            if(this.controllerRecipe) {
                this.controllerRecipe.abort();
            }
            this.controllerRecipe = new AbortController();

            this.loadingRecipes = true
            try {
                let params = {
                    ...this.filters,
                    query: query
                }
                let response = await axios.get('/pro/recipes/autocomplete', {
                    params,
                    signal: this.controllerRecipe.signal
                });
                this.recipes = response.data
            } catch (e) {
                console.log(e)
            }
            this.loadingRecipes = false
        },
        async filterByUser(user)
        {
            this.filters.user = user.user_id
            await this.search()
        }
    }
}
</script>

<style scoped>
.table th {
    text-transform: none;
}
.stat-ctn {
    display: flex;
    align-items: center;
    justify-content: center;
}
. icon-letter {
    border-radius: 50px;
    width: 28px;
    height: 28px !important;
    padding: 0;
}
</style>
